import { forwardRef, useMemo } from 'react'
import { Box, TextField as MuiTextField } from '@mui/material'
import PropTypes from 'prop-types'

const TextField = forwardRef((props, ref) => {
  const { editable, highlighted, sx: sxProp, ...rest } = props

  const editableSx = useMemo(
    () => ({
      ...sxProp,
      '& .MuiOutlinedInput-notchedOutline': highlighted
        ? {
            border: (theme) =>
              `2px solid ${theme.palette.input.border.highlighted}`,
          }
        : {},
    }),
    [highlighted, sxProp]
  )

  const readOnlySx = useMemo(
    () => ({
      border: (theme) =>
        highlighted
          ? `2px solid ${theme.palette.input.border.highlighted}`
          : `1px solid ${theme.palette.input.border.default}`,
      borderRadius: '4px',
      color: !rest.value && 'inactive.text',
      flexGrow: 1,
      p: '7px 12px',
    }),
    [highlighted, rest.value]
  )

  return editable ? (
    <MuiTextField ref={ref} {...rest} sx={editableSx} />
  ) : (
    <Box ref={ref} sx={readOnlySx}>
      {rest.value || rest.placeholder}
    </Box>
  )
})

TextField.displayName = 'TextField'

TextField.propTypes = {
  editable: PropTypes.bool,
  highlighted: PropTypes.bool,
  sx: PropTypes.oneOfType([PropTypes.object, PropTypes.func]),
}

export default TextField
